import React, { useContext, useEffect, useState } from "react";
import { getStoresApi } from "../../Apis/StoreApi";
import { UserAuthContext } from "../../App";

const ContactSection = () => {
  const {userUid} = useContext(UserAuthContext);
  const [storeDetails , setStoreDetails]= useState([]);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const fetchStoreDetails = async ()=>{
    try{
      const response = await getStoresApi(userUid?.currentUser?.uid);
      setStoreDetails(response?.store)
    }catch(error){
      console.log("Failed to fetch the store details", error);
    }
  }

  useEffect(()=>{
    if (userUid?.currentUser) {
      fetchStoreDetails();
      setPhone(userUid.currentUser.phoneNumber || "");
      setEmail(userUid.currentUser.email || "");
    }
  },[userUid?.currentUser])

  const displayPhone = storeDetails?.phoneNumber || phone;

  return (
    <div className="w-full bg-white">
      <div className="container max-w-[1240px] mx-auto w-full h-[530px] flex flex-col">
        <div className="w-[1240px] h-[434px] bg-white rounded-[10px] mt-[50px] border pt-[20px] pl-[35px] pb-[36px] pr-[82px] flex flex-col items-center justify-start">
          <h2 className="w-[113px] h-[30px] font-semibold text-[20px] text-[#FF6300]">
            Contact Us
          </h2>
          <p className="w-[397px] h-[24px] font-medium text-[16px] text-center text-black mt-[12px]">
            Question not answered yet ? we are here to help !
          </p>
          <div className="w-full flex flex-row items-start justify-between mt-[26px]">
            <div className="w-[654px] h-[286px] flex flex-col gap-y-[20px]">
              <div className="w-[654px] h-[82px] rounded-[5px] bg-[#FFF9F2] flex items-center justify-between px-[13px] py-[16px]">
                <div className="flex flex-row gap-x-[32px]">
                  <p className="w-[50px] h-[50px] rounded-full bg-white border flex items-center justify-center">
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.9654 19.5669C14.2202 19.5672 13.4878 19.3727 12.8408 19.0028L12.7496 18.9514C8.54319 16.5452 5.02405 13.1006 2.52837 8.94671L2.05261 8.15378C1.56534 7.34313 1.36342 6.3927 1.47904 5.45397C1.59466 4.51523 2.02116 3.64221 2.69058 2.97402L3.63848 2.02612C4.43503 1.22957 5.73051 1.22957 6.52634 2.02612L8.61475 4.11454C8.92905 4.43032 9.13187 4.83993 9.1925 5.28132C9.25313 5.72272 9.16826 6.17184 8.95075 6.56068L8.16579 7.95464C8.14929 7.98397 8.14284 8.01789 8.14741 8.05123C8.15199 8.08457 8.16734 8.1155 8.19113 8.1393L12.8408 12.789C12.865 12.8127 12.8962 12.8279 12.9298 12.8323C12.9633 12.8368 12.9974 12.8302 13.0269 12.8136L14.4187 12.0294L14.4194 12.0286C14.8083 11.8114 15.2574 11.7266 15.6987 11.7873C16.1401 11.8479 16.5497 12.0506 16.8656 12.3646L18.9547 14.4545C19.7513 15.2511 19.7513 16.5465 18.9547 17.3424L17.9648 18.3315C17.5706 18.7245 17.1028 19.0358 16.5881 19.2478C16.0734 19.4598 15.522 19.5682 14.9654 19.5669ZM5.08241 2.87699C4.93034 2.87699 4.77827 2.93492 4.66241 3.05078L3.71451 3.99795C3.27392 4.43775 2.99321 5.01235 2.91709 5.63021C2.84097 6.24806 2.97384 6.87361 3.29451 7.40719L3.77027 8.20012C6.13758 12.1407 9.47569 15.4085 13.4658 17.6914L13.557 17.7428C14.662 18.375 16.0524 18.1961 16.9402 17.3069L17.9301 16.3177C17.9852 16.2626 18.029 16.1971 18.0589 16.125C18.0887 16.053 18.1041 15.9757 18.1041 15.8977C18.1041 15.8197 18.0887 15.7425 18.0589 15.6704C18.029 15.5983 17.9852 15.5329 17.9301 15.4777L15.8409 13.3878C15.749 13.2965 15.6297 13.2375 15.5013 13.22C15.3728 13.2025 15.2422 13.2274 15.1291 13.2908L13.7373 14.0751C13.4321 14.2459 13.0796 14.3127 12.7331 14.2652C12.3866 14.2178 12.0649 14.0588 11.8169 13.8122L7.1672 9.1625C6.92037 8.91477 6.76114 8.59324 6.71369 8.24676C6.66625 7.90028 6.73319 7.54778 6.90434 7.24281L7.6893 5.84957C7.75237 5.73649 7.77694 5.60595 7.75931 5.47768C7.74167 5.3494 7.68279 5.23034 7.59154 5.13847L5.50241 3.05078C5.44729 2.99558 5.38181 2.95182 5.30974 2.92199C5.23766 2.89217 5.16041 2.87687 5.08241 2.87699Z"
                        fill="black"
                      />
                    </svg>
                  </p>
                  <div className="flex flex-col items-start justify-between">
                    <p className="w-[32px] h-[24px] font-medium text-[16px] text-black text-start">
                      Call
                    </p>
                    <p className="w-[256px] h-[24px] font-regular text-[16px] text-start text-black">
                      Call with a member of our team {displayPhone} 
                    </p>
                  </div>
                </div>
                <button className="w-[99px] h-[33px] bg-[#FF6300] font-medium text-[14px] text-white flex items-center justify-center rounded-[5px]">
                  View
                </button>
              </div>

              <div className="w-[654px] h-[82px] rounded-[5px] bg-[#FFF9F2] flex items-center justify-between px-[13px] py-[16px]">
                <div className="flex flex-row gap-x-[32px]">
                  <p className="w-[50px] h-[50px] rounded-full bg-white border flex items-center justify-center">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_360_646)">
                        <path
                          d="M3.125 7.29159C3.125 6.73905 3.34449 6.20915 3.73519 5.81845C4.12589 5.42775 4.6558 5.20825 5.20833 5.20825H19.7917C20.3442 5.20825 20.8741 5.42775 21.2648 5.81845C21.6555 6.20915 21.875 6.73905 21.875 7.29159V17.7083C21.875 18.2608 21.6555 18.7907 21.2648 19.1814C20.8741 19.5721 20.3442 19.7916 19.7917 19.7916H5.20833C4.6558 19.7916 4.12589 19.5721 3.73519 19.1814C3.34449 18.7907 3.125 18.2608 3.125 17.7083V7.29159Z"
                          stroke="black"
                          stroke-width="1.83333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.125 7.29175L12.5 13.5417L21.875 7.29175"
                          stroke="black"
                          stroke-width="1.83333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_360_646">
                          <rect width="25" height="25" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </p>
                  <div className="flex flex-col items-start justify-between">
                    <p className="w-[45px] h-[24px] font-medium text-[16px] text-black text-start">
                      Email
                    </p>
                    <p className="w-[379px] h-[24px] font-regular text-[16px] text-start text-black">
                      Just send your questions by starting email {email}
                    </p>
                  </div>
                </div>
                <button className="w-[99px] h-[33px] bg-[#FF6300] font-medium text-[14px] text-white flex items-center justify-center rounded-[5px]">
                  View
                </button>
              </div>

              <div className="w-[654px] h-[82px] rounded-[5px] bg-[#FFF9F2] flex items-center justify-between px-[13px] py-[16px]">
                <div className="flex flex-row gap-x-[32px]">
                  <p className="w-[50px] h-[50px] rounded-full bg-white border flex items-center justify-center">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_360_650)">
                        <path
                          d="M9.375 11.4583C9.375 12.2871 9.70424 13.0819 10.2903 13.668C10.8763 14.254 11.6712 14.5833 12.5 14.5833C13.3288 14.5833 14.1237 14.254 14.7097 13.668C15.2958 13.0819 15.625 12.2871 15.625 11.4583C15.625 10.6295 15.2958 9.83459 14.7097 9.24854C14.1237 8.66249 13.3288 8.33325 12.5 8.33325C11.6712 8.33325 10.8763 8.66249 10.2903 9.24854C9.70424 9.83459 9.375 10.6295 9.375 11.4583Z"
                          stroke="black"
                          stroke-width="1.83333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.393 17.351L13.9732 21.7708C13.5826 22.161 13.053 22.3802 12.5009 22.3802C11.9487 22.3802 11.4191 22.161 11.0285 21.7708L6.60762 17.351C5.44223 16.1855 4.6486 14.7007 4.32709 13.0842C4.00558 11.4677 4.17063 9.79214 4.80137 8.26945C5.43212 6.74676 6.50022 5.44529 7.87062 4.52963C9.24102 3.61397 10.8522 3.12524 12.5003 3.12524C14.1485 3.12524 15.7596 3.61397 17.13 4.52963C18.5004 5.44529 19.5685 6.74676 20.1993 8.26945C20.83 9.79214 20.9951 11.4677 20.6736 13.0842C20.3521 14.7007 19.5584 16.1855 18.393 17.351Z"
                          stroke="black"
                          stroke-width="1.83333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_360_650">
                          <rect width="25" height="25" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </p>
                  <div className="flex flex-col items-start justify-between">
                    <p className="w-[66px] h-[24px] font-medium text-[16px] text-black text-start">
                      Address
                    </p>
                    <p className="w-[350px] h-[24px] font-regular text-[16px] text-start text-black">
                      {storeDetails?.storeAddress}
                    </p>
                  </div>
                </div>
                <button className="w-[99px] h-[33px] bg-[#FF6300] font-medium text-[14px] text-white flex items-center justify-center rounded-[5px]">
                  View
                </button>
              </div>
            </div>

            <div className="h-full items-center justify-center flex">
              <img
                src={require("../../assets/WebFront/Contact/image 264.jpg")}
                alt=""
                className="w-[185px] h-[106px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
